import React from 'react'
import Announcement from '../components/Main/Announcement'
import CtaBanner from '../components/Main/CtaBanner'
import RowList from '../components/Main/RowList'
import Page from '../components/Page'
import Video from '../components/Main/Video'

export default function Scholarships (props) {
  const {
    //Hero Section fields
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,

    //Announcements
    announcement_heading: announceHeading,
    announcement_body: announceBody,

    //Video
    include_video: includeVideo,
    video_poster: videoPoster,
    video_url: videoUrl,
    video_copy: videoCopy,

    //RowList Scholarships Repeater
    scholarships: scholarships,
    inactive_button_text: inactiveText,

    //CtaBanner
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.acf

  return (
    <Page
      title={introHeading}
      body={introParagraph}
      bgImage={introImage}
      bgId={imageId}
      alt={alt}
      height={height}
      width={width}
      slug={'/' + introHeading}
    >
      <main id='content'>
        <a className='skip' id='skip'></a>
        <div className='scholarship-list container-fluid'>
          <div className='announcement'>
            <Announcement
              title={announceHeading}
              body={announceBody}
              hidehr={true}
            />
          </div>

          {scholarships.map((scholarshipsitem, i) => (
            <RowList
              scholarship
              key={scholarshipsitem.scholarship_name}
              title={scholarshipsitem.scholarship_name}
              body={scholarshipsitem.scholarship_description}
              link={scholarshipsitem.scholarship_link.url}
              button={scholarshipsitem.scholarship_link.title}
              active={scholarshipsitem.scholarship_active}
              inactiveText={inactiveText}
              lastItem={scholarships.length === i + 1}
            />
          ))}
          {includeVideo && (
            <div className='video-and-copy'>
              {videoCopy && (
                <div
                  className='video-copy'
                  dangerouslySetInnerHTML={{ __html: videoCopy }}
                />
              )}
              <Video poster={videoPoster} url={videoUrl} />
            </div>
          )}
        </div>
      </main>
      {/* <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} /> */}
    </Page>
  )
}
